import CheckIcon from '@svg/check.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './RadioInput.module.scss';

function RadioInput({ id, name, onChange, label, checked, value, required }) {
  const inputId = `${name}-${id}`;
  return (
    // COMMENT: The div is required for rendering reasons
    <div>
      <input
        className={classNames(styles.input, 'u-visually-hidden')}
        onChange={onChange}
        required={required}
        checked={checked}
        value={value}
        id={inputId}
        type="radio"
        name={name}
      />
      <label htmlFor={inputId} className={styles.labelWrapper}>
        <span className={styles.indicator}>
          <CheckIcon className={styles.icon} />
        </span>
        <span className={styles.label}>{label}</span>
      </label>
    </div>
  );
}

RadioInput.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  checked: PropTypes.bool,
};

export default RadioInput;
